module.exports = __webpack_public_path__ + "img/Tomography.536689a4.svg";